import { useAuthStore } from './auth.store'

export const getToken = () => {
  const token = useAuthStore.getState().accessToken

  return token
}

export const clearAuthToken = () => {
  localStorage.clear()
  sessionStorage.clear()
  return
}
